"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OfficeThemeColorDestination = void 0;
var tslib_1 = require("tslib");
var drawing_color_1 = require("../../../../../core/model/drawing/drawing-color");
var drawing_color_model_info_1 = require("../../../../../core/model/drawing/drawing-color-model-info");
var drawing_color_destination_1 = require("./drawing-color-destination");
var OfficeThemeColorDestination = (function (_super) {
    tslib_1.__extends(OfficeThemeColorDestination, _super);
    function OfficeThemeColorDestination(data, themeColorIndex) {
        var _this = _super.call(this, data, new drawing_color_1.DrawingColor(new drawing_color_model_info_1.DrawingColorModelInfo())) || this;
        _this.themeColorIndex = themeColorIndex;
        return _this;
    }
    OfficeThemeColorDestination.prototype.processElementClose = function (_reader) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                this.data.documentModel.colorProvider.officeTheme.colors.setDrawingColor(this.themeColorIndex, this.color);
                return [2];
            });
        });
    };
    return OfficeThemeColorDestination;
}(drawing_color_destination_1.DrawingColorDestination));
exports.OfficeThemeColorDestination = OfficeThemeColorDestination;
